const tabRole = () => {
  function changeTabs(e) {
    const { target } = e;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;
    const currentTabs = grandparent.querySelectorAll('[aria-controls]');
    for (let i = 0; i < currentTabs.length; i++) { /* eslint-disable-line no-plusplus */
      // Remove all current selected tabs
      currentTabs[i].setAttribute('aria-selected', false);
      // Hide all tab panels
      document.getElementById(currentTabs[i].getAttribute('aria-controls')).setAttribute('hidden', true);
    }
    // Set this tab as selected
    target.setAttribute('aria-selected', true);
    // Show the selected panel
    document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');
  }

  const addTablistEvents = (tabList) => {
    const tabs = tabList.querySelectorAll('[role="tab"]');
    for (let i = 0; i < tabs.length; i++) { /* eslint-disable-line no-plusplus */
      tabs[i].addEventListener('click', changeTabs);
    }
    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;
    tabList.addEventListener('keydown', (e) => {
      // Move right
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute('tabindex', -1);
        if (e.keyCode === 39) {
          tabFocus++; /* eslint-disable-line no-plusplus */
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
          // Move left
        } else if (e.keyCode === 37) {
          tabFocus--; /* eslint-disable-line no-plusplus */
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }
        tabs[tabFocus].setAttribute('tabindex', 0);
        tabs[tabFocus].focus();
      }
    });
  };

  // init
  const tabList = document.querySelectorAll('[role="tablist"]');
  // Add a click event handler to each tab
  for (let i = 0; i < tabList.length; i++) { /* eslint-disable-line no-plusplus */
    addTablistEvents(tabList[i]);
  }
};

export default tabRole;
